import { createTheme, PaletteOptions } from "@mui/material/styles";
import { TypographyStyleOptions } from "@mui/material/styles/createTypography";

// TODO - get imports to work from DV repo
// import * as colors from '@dv/colors';
import * as colors from "./colors";

import { fontFamilies } from "./fontfamilies";

declare module "@mui/material/styles/createPalette" {
  export interface PaletteOptions {
    all: colors.Colors;
  }
}

declare module "@mui/material/styles" {
  interface TypographyVariants {
    body3: TypographyStyleOptions;
    widgetHeadingSmall: TypographyStyleOptions;
    supplement: TypographyStyleOptions;
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    body3?: TypographyStyleOptions;
    widgetHeadingSmall?: TypographyStyleOptions;
    supplement?: TypographyStyleOptions;
  }
}

// Update the Typography's variant prop options
declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    body3: true;
    widgetHeadingSmall: true;
    supplement: true;
  }
}

export interface EmotionProps {
  theme: {
    palette?: PaletteOptions;
  };
}

export const lightTheme = createTheme({
  components: {
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          // Controls default (unchecked) color for the thumb
          color: colors.neutralgray[500]
        },
        track: {
          // Controls default (unchecked) color for the track
          opacity: 0.12,
          backgroundColor: colors.neutralgray[500]
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          minWidth: 200
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          color: colors.coolgray[800],
          backgroundColor: colors.neutralgray[50]
        }
      }
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 400,
      md: 768,
      lg: 1440,
      xl: 1920
    }
  },
  palette: {
    action: {
      disabledBackground: colors.neutralgray[300]
    },
    background: {
      default: colors.neutralgray[50]
    },
    all: {
      ...colors
    },
    error: {
      main: colors.tomato[500]
    },
    primary: {
      contrastText: colors.white[500],
      dark: colors.plum[700],
      main: colors.plum[500]
    },
    secondary: {
      contrastText: colors.white[500],
      main: colors.berry[500],
      dark: colors.berry[700]
    },
    text: {
      disabled: colors.neutralgray[200],
      primary: colors.coolgray[900],
      secondary: colors.coolgray[800]
    }
  },
  typography: {
    fontFamily: fontFamilies.roboto,
    fontSize: 14,
    fontWeightBold: 700,
    fontWeightLight: 300,
    fontWeightMedium: 500,
    fontWeightRegular: 400,
    button: {
      fontWeight: 700,
      fontSize: "1rem",
      lineHeight: "1.25rem",
      textTransform: "none"
    },
    h1: {
      fontSize: "2.5rem",
      lineHeight: "3.25rem",
      fontWeight: 500
    },
    h2: {
      fontSize: "2.25rem",
      lineHeight: "3.25rem",
      fontWeight: 500
    },
    h3: {
      fontSize: "2rem",
      lineHeight: "3rem",
      fontWeight: 500
    },
    h4: {
      fontSize: "1.75rem",
      lineHeight: "2.75rem",
      fontWeight: 500
    },
    h5: {
      fontSize: "1.5rem",
      lineHeight: "2.25rem",
      fontWeight: 500
    },
    h6: {
      fontSize: "1.25rem",
      lineHeight: "1.75rem",
      fontWeight: 500
    },
    widgetHeadingSmall: {
      fontSize: "1rem",
      lineHeight: "1.5rem",
      fontWeight: 500
    },
    body1: {
      fontSize: "1.125rem",
      lineHeight: "1.75rem"
    },
    body2: {
      fontSize: "1rem",
      lineHeight: "1.5rem"
    },
    body3: {
      fontSize: "0.875rem",
      lineHeight: "1.375rem"
    },
    supplement: {
      fontSize: "0.75rem",
      lineHeight: "1rem"
    }
  }
});
